let firstRender = true;

document.addEventListener(
  'focusin',
  (event) => {
    if (window.innerWidth >= 1024) return;
    const input = event.target && event.target.closest && event.target.closest('.aa-Input');
    if (!input) return;
    input.focus();
  },
  true
);

const focusAlgoliaInputWhenReady = (options = {}) => {
  const { delay = 0 } = options;
  const tryFocus = () => {
    const input = document.querySelector('.aa-Form .aa-Input, .aa-Input');
    if (!input) return false;
    input.focus();
    return true;
  };

  const startFocus = () => {
    if (tryFocus()) return;
    requestAnimationFrame(() => {
      if (tryFocus()) return;
      setTimeout(() => {
        tryFocus();
      }, 0);
    });

    const observer = new MutationObserver(() => {
      if (tryFocus()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 2000);
  };

  if (delay > 0) {
    setTimeout(startFocus, delay);
    return;
  }
  startFocus();
};

document.addEventListener(
  'click',
  (event) => {
    const pathname = window.location.pathname || '';
    const shouldAutoOpen =
      pathname.includes('/products/') ||
      pathname.includes('/pages/') ||
      pathname.includes('/account') ||
      pathname.includes('/blogs/');
    if (!shouldAutoOpen) return;
    if (window.innerWidth >= 1024) return;
    const trigger = event.target && event.target.closest && event.target.closest('#main-search-trigger');
    if (!trigger) return;
    event.preventDefault();
    const details = trigger.closest('details') || document.querySelector('.header__search details');
    if (details && !details.hasAttribute('open')) {
      details.setAttribute('open', '');
    }
    const detachedButton = document.querySelector('.aa-DetachedSearchButton');
    if (detachedButton) {
      detachedButton.click();
    }
    focusAlgoliaInputWhenReady({ delay: 50 });
  },
  true
);

document.addEventListener(
  'click',
  (event) => {
    const cancelButton = event.target && event.target.closest && event.target.closest('.aa-DetachedCancelButton');
    if (!cancelButton) return;
    const input = document.querySelector('.aa-Form .aa-Input, .aa-Input');
    if (input) {
      input.classList.add('is-visible');
    }
    const pathname = window.location.pathname || '';
    const shouldHideModal =
      pathname.includes('/products/') ||
      pathname.includes('/pages/') ||
      pathname.includes('/account') ||
      pathname.includes('/blogs/');
    if (shouldHideModal && window.innerWidth < 680) {
      const searchModal = document.querySelector('.search-modal.modal__content.gradient');
      if (searchModal) {
        searchModal.style.display = 'none';
      }
    }
  },
  true
);

const clearDetachedSearchQuery = () => {
  const query = document.querySelector('.aa-DetachedSearchButtonQuery');
  if (query) {
    query.textContent = '';
  }
};

document.addEventListener(
  'click',
  (event) => {
    const searchButton = event.target && event.target.closest && event.target.closest('.aa-DetachedSearchButton');
    if (!searchButton) return;
    clearDetachedSearchQuery();
    requestAnimationFrame(clearDetachedSearchQuery);
    setTimeout(clearDetachedSearchQuery, 0);
  },
  true
);

document.addEventListener(
  'click',
  (event) => {
    const cancelButton = event.target && event.target.closest && event.target.closest('.aa-DetachedCancelButton');
    if (!cancelButton) return;
    clearDetachedSearchQuery();
    requestAnimationFrame(clearDetachedSearchQuery);
    setTimeout(clearDetachedSearchQuery, 0);
  },
  true
);

const detachedQueryObserver = new MutationObserver(clearDetachedSearchQuery);
detachedQueryObserver.observe(document.documentElement, {
  subtree: true,
  childList: true,
  characterData: true,
});

const removeDetachedPlaceholderHidden = () => {
  const input = document.querySelector('.aa-Form .aa-Input, .aa-Input');
  if (input) {
    input.classList.add('is-visible');
  }
};

document.addEventListener('DOMContentLoaded', removeDetachedPlaceholderHidden);
document.addEventListener('algolia.hooks.initialize', removeDetachedPlaceholderHidden);

const placeholderObserver = new MutationObserver(removeDetachedPlaceholderHidden);
placeholderObserver.observe(document.documentElement, {
  subtree: true,
  childList: true,
  attributes: true,
  attributeFilter: ['hidden'],
});

// On <1024px and on homepage or collections pages, this creates (if missing) the "Zamknij" button inside
// `.search-modal__content`, clears `.aa-Input` on click, restores the modal to its default position/state,
// sets `body` overflow back to `auto`, removes `.aa-Panel`, and triggers scroll/resize to re-apply layout.
const ensureTypingCloseButton = () => {
  const content = document.querySelector('.search-modal__content');
  if (!content) return null;
  let button = content.querySelector('.yk-typing-close');
  if (button) return button;

  button = document.createElement('button');
  button.type = 'button';
  button.className = 'yk-typing-close';
  button.textContent = 'Zamknij';
  button.addEventListener('click', () => {
    const input = document.querySelector('.aa-Input');
    if (input) {
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    document.body.style.overflow = 'auto';

    const searchModal = document.querySelector('.search-modal.modal__content.gradient');
    if (searchModal) {
      searchModal.classList.remove('yk-search-modal-active');
      searchModal.style.backgroundColor = 'transparent';
    }

    const panel = document.querySelector('.aa-Panel');
    if (panel) panel.remove();

    const tabs = document.querySelector('.YkCategoryTabsMobile');
    if (tabs && tabs.dataset.ykHiddenOnSearch === 'true') {
      tabs.style.display = '';
      delete tabs.dataset.ykHiddenOnSearch;
    }

    window.dispatchEvent(new Event('scroll'));
    window.dispatchEvent(new Event('resize'));
  });

  content.appendChild(button);
  return button;
};

const updateSearchModalTypingState = (value) => {
  const searchModal = document.querySelector('.search-modal.modal__content.gradient');
  if (!searchModal) return;
  const pathname = window.location.pathname || '';
  const isHomepage = pathname === '/' || document.body.classList.contains('template--index');
  const isCollections = pathname.startsWith('/collections');
  if (window.innerWidth >= 1024) {
    searchModal.classList.remove('yk-search-modal-active');
    return;
  }
  const hasQuery = (value || '').trim().length > 0;
  if (isHomepage || isCollections) {
    searchModal.classList.toggle('yk-search-modal-active', hasQuery);
  }
  document.body.style.overflow = hasQuery ? 'hidden' : 'auto';
  if (hasQuery && (isHomepage || isCollections)) {
    const updatePanelTop = () => {
      const panel = document.querySelector('.aa-Panel');
      if (!panel) return;
      const rect = searchModal.getBoundingClientRect();
      panel.style.top = `${rect.bottom + window.scrollY}px`;
    };
    requestAnimationFrame(updatePanelTop);
    setTimeout(updatePanelTop, 0);
  }

  if (isHomepage || isCollections) {
    const closeButton = ensureTypingCloseButton();
    if (closeButton) {
      closeButton.hidden = !hasQuery;
    }
  }
};

document.addEventListener(
  'input',
  (event) => {
    const input = event.target && event.target.closest && event.target.closest('.aa-Input');
    if (!input) return;
    updateSearchModalTypingState(input.value);
  },
  true
);

const isIOS = /iP(ad|hone|od)/.test(navigator.userAgent);
if (isIOS) {
  document.body.classList.add('yk-ios');
}


document.addEventListener(
  'focusin',
  (event) => {
    const input = event.target && event.target.closest && event.target.closest('.aa-Input');
    if (!input) return;
    if (window.innerWidth >= 1024) return;
    const scrolled = (window.scrollY || document.documentElement.scrollTop) >= 40;
    if (isIOS && scrolled) return;
    if (scrolled) return;
    const isHomepage = window.location.pathname === '/' || document.body.classList.contains('template--index');
    if (!isHomepage) return;
    const topbar = document.querySelector('.topbar');
    const header = document.querySelector('.header');
    const searchModal = document.querySelector('.search-modal.modal__content.gradient');
    if (searchModal && topbar && header) {
      console.log(">>>>><<<<<")
      searchModal.style.top = `${topbar.offsetHeight + header.offsetHeight}px`;
    }
    const tabs = document.querySelector('.YkCategoryTabsMobile');
    if (tabs) {
      tabs.dataset.ykHiddenOnSearch = 'true';
      tabs.style.display = 'none';
    }
  },
  true
);

document.addEventListener(
  'focusout',
  (event) => {
    const input = event.target && event.target.closest && event.target.closest('.aa-Input');
    if (!input) return;
    const searchModal = document.querySelector('.search-modal.modal__content.gradient');
    if (searchModal && searchModal.classList.contains('yk-search-modal-active')) return;
    if (window.innerWidth >= 1024) return;
    const isHomepage = window.location.pathname === '/' || document.body.classList.contains('template--index');
    const isCollections = window.location.pathname.startsWith('/collections');
    if (!isHomepage && !isCollections) {
      window.dispatchEvent(new Event('scroll'));
      window.dispatchEvent(new Event('resize'));
      return;
    }
    const scrolled = (window.scrollY || document.documentElement.scrollTop) >= 40;
    if (scrolled) return;
    const topbar = document.querySelector('.topbar');
    const header = document.querySelector('.header');
    if (searchModal && topbar && header) {
      let nextTop = `${topbar.offsetHeight + header.offsetHeight + 52}px`;
      if (window.innerWidth >= 768 && window.innerWidth <= 1024) {
        nextTop = `${topbar.offsetHeight + header.offsetHeight}px`;
      }
      searchModal.style.top = nextTop;
    }
    const tabs = document.querySelector('.YkCategoryTabsMobile');
    if (tabs && tabs.dataset.ykHiddenOnSearch === 'true') {
      tabs.style.display = '';
      delete tabs.dataset.ykHiddenOnSearch;
    }
  },
  true
);

document.addEventListener(
  'scroll',
  () => {
    if (isIOS) return;
    const isHomepage = window.location.pathname === '/' || document.body.classList.contains('template--index');
    if (!isHomepage) return;
    const input = document.querySelector('.aa-Input');
    const scrolled = (window.scrollY || document.documentElement.scrollTop) >= 40;
    const tabs = document.querySelector('.YkCategoryTabsMobile');

    if (scrolled) {
      if (input && document.activeElement === input) {
        input.blur();
      }
      return;
    }

    if (tabs && tabs.dataset.ykHiddenOnSearch === 'true') {
      if (input && document.activeElement === input) {
        input.blur();
      }
      tabs.style.display = '';
      delete tabs.dataset.ykHiddenOnSearch;
    }
  },
  { passive: true }
);

document.addEventListener(
  'click',
  (event) => {
    const cancelButton = event.target && event.target.closest && event.target.closest('.aa-DetachedCancelButton');
    if (!cancelButton) return;
    updateSearchModalTypingState('');
  },
  true
);

document.addEventListener(
  'click',
  (event) => {
    const trigger = event.target && event.target.closest && event.target.closest('#main-search-trigger');
    if (!trigger) return;
    const details = trigger.closest('details') || document.querySelector('.header__search details');
    const panelOpen = document.querySelector('.aa-Panel');
    if (details?.hasAttribute('open') && panelOpen) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    if (window.innerWidth >= 1024) return;
    const pathname = window.location.pathname || '';
    const isHomepage = pathname === '/' || document.body.classList.contains('template--index');
    const isCollections = pathname.startsWith('/collections');
    if (isHomepage || isCollections) return;
    const searchModal = document.querySelector('.search-modal.modal__content.gradient');
    if (searchModal) {
      searchModal.style.backgroundColor = 'white';
    }
  },
  true
);

document.addEventListener(
  'click',
  (event) => {
    const clearButton = event.target && event.target.closest && event.target.closest('.aa-ClearButton');
    if (!clearButton) return;
    document.body.style.overflow = 'auto';
    if (window.innerWidth > 1024) {
      const searchModal = document.querySelector('.search-modal.modal__content.gradient');
      if (searchModal) {
        console.log("yk-algolia-ui.js clearButton click...")
        searchModal.style.top = '0px';
      }
    }
    window.dispatchEvent(new Event('scroll'));
    window.dispatchEvent(new Event('resize'));
  },
  true
);

document.addEventListener(
  'click',
  (event) => {
    const closeButton = event.target && event.target.closest && event.target.closest('.modal__close-button');
    if (!closeButton) return;
    document.body.style.overflow = 'auto';
  },
  true
);


document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function (options) {
    options.placeholder = 'Szukaj po nazwie, potrzebie, opisie...';
    options.detachedMediaQuery = 'none';
    return options;
  });
});

const initDetachedPlaceholderRotation = () => {
  const input = document.querySelector('.aa-Form .aa-Input, .aa-Input');
  if (!input || input.dataset.rotatingPlaceholder === 'true') return;

  const texts = [
    'Szukaj po nazwie, potrzebie, opisie...',
    'Olejek intymny',
    'Podpaski z bawełny organicznej',
    'Żel intymny',
    'More Collagen',
    'Nawilżający żel do mycia twarzy i okolic oczu',
    'Delikatny dezodorant pod pachy i biust',
    'Serum przeciw wrastającym włoskom',
    'Łagodzący płyn do higieny intymnej',
    'Tampony',
    'Chusteczki do higieny intymnej',
    'Wkładki higieniczne',
    'Krem do golenia',
    'Pielęgnujący róż do policzków'
  ];

  let index = 0;
  input.dataset.rotatingPlaceholder = 'true';
  input.setAttribute('placeholder', texts[index]);
  input.classList.add('yk-rotating-placeholder');

  setTimeout(() => {
    setInterval(() => {
      input.classList.remove('is-visible');
      setTimeout(() => {
        index = (index + 1) % texts.length;
        input.setAttribute('placeholder', texts[index]);
        input.classList.add('is-visible');
      }, 300);
    }, 2000);
  }, 2000);

  requestAnimationFrame(() => input.classList.add('is-visible'));
};

const observeDetachedPlaceholder = () => {
  initDetachedPlaceholderRotation();
  const observer = new MutationObserver(() => {
    if (document.querySelector('.aa-Form .aa-Input, .aa-Input')) {
      initDetachedPlaceholderRotation();
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
};

document.addEventListener('DOMContentLoaded', observeDetachedPlaceholder);
document.addEventListener('algolia.hooks.initialize', observeDetachedPlaceholder);

document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook(
    'beforeAutocompleteNoResultsTemplate',
    function (_defaultTemplate, templateOptions) {
      const { html, state } = templateOptions;
      return html`
        <div class="aa-PanelLayout aa-Panel--scrollable">
          <div class="flex w-fit flex-col gap-3 mx-auto min-w-[650px]">
            <p class="font-sans text-xs font-medium leading-normal text-gray100 tracking-[0.32px]">Brak wyników</p>
            <p class="font-sans text-xs font-medium leading-normal text-text-black01 tracking-[0.32px]">
              Przepraszamy, nie znaleźliśmy wyników dla “${state.query}”.
            </p>
            <a
              class="w-fit mt-2 bg-white text-text-black01 border-text-black01 hover:bg-text-black01 hover:text-white hover:border-white border border-gray40 h-10 border-solid px-5 rounded-sm font-semibold py-2 transition uppercase font-sans text-xs shrink-0 leading-5 tracking-[2px]"
              href="/collections/wszystkie-produkty"
            >
              Zobacz wszystkie produkty
            </a>
          </div>
        </div>
      `;
    }
  );
});

document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook(
    'beforeAutocompleteProductTemplate',
    function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
      const { html, item, components } = templateOptions;
      return html`
        <a href="${itemLink}" class="aa-ItemLink aa-ProductItem" onClick="${() => trackSearchAttribution(item)}">
          <div class="aa-ItemContent">
            <div class="aa-ItemPicture aa-ItemPicture--loaded">
              <img
                src="${algoliaShopify.helpers.renderImage(item, 300).src}"
                srcset="${algoliaShopify.helpers.renderImage(item, 300).srcset}"
                sizes="${algoliaShopify.helpers.renderImage(item, 300).sizes}"
                alt="${item.title}"
              />
            </div>
            <div class="aa-ItemContentBody">
              <div class="aa-ItemContentBrand">
                ${item.product_type && components.Highlight({ hit: item, attribute: 'product_type' })} removing vendor
              </div>
              <div class="aa-ItemContentTitleWrapper">
                <div class="aa-ItemContentTitle">
                  ${components.Highlight({ hit: item, attribute: 'title' })}
                  <span class="algolia-variant"> ${algoliaShopify.helpers.variantTitleAddition(item, distinct)} </span>
                </div>
              </div>
              <div class="aa-ItemContentPrice">
                <div class="aa-ItemContentPriceCurrent">
                  ${item.variants_max_price > item.variants_min_price ? 'od ' : ''}
                  ${new Intl.NumberFormat('pl-PL', {
                    style: 'currency',
                    currency: 'PLN',
                  }).format(item.variants_min_price)}
                </div>
              </div>
            </div>
          </div>
        </a>
      `;
    }
  );
});

document.addEventListener('algolia.hooks.initialize', function () {
  const dictionary = {
    Collections: 'Kategorie',
    Products: 'Produkty',
    No: 'Brak',
    results: 'wyników',
    for: 'dla:',
    See: 'Zobacz',
    all: 'wszystkie',
    products: 'produkty',
  };

  algoliaShopify.hooks.registerHook(
    'beforeAutocompleteHeaderTemplate',
    function (_defaultTemplate, templateOptions, resource) {
      const { html, state } = templateOptions;
      return html`
        <div class="aa-SourceHeader">
          <span class="aa-SourceHeaderTitle">
            ${algoliaShopify.translation_helpers.render_title(dictionary[resource] || resource, state.query)}
          </span>
          <div class="aa-SourceHeaderLine" />
        </div>
      `;
    }
  );
});

document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook(
    'beforeAutocompleteCollectionsTemplate',
    function (_defaultTemplate, templateOptions, itemLink) {
      const { html, item, components } = templateOptions;
      return html`
        <a href="${itemLink}" class="aa-ItemLink">
          <div class="aa-ItemWrapper">
            <div class="aa-ItemContent">
              <div class="aa-ItemContentBody">
                <div class="aa-ItemContentTitle yk-CollectionItem">
                  ${components.Highlight({ hit: item, attribute: 'title' })}
                </div>
              </div>
            </div>
          </div>
        </a>
      `;
    }
  );
});

//
//
//

document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook(
    'beforeInstantSearchProductTemplate',
    function (_defaultTemplate, hit, html, components, trackSearchAttribution) {
      if (firstRender) {
        setTimeout(() => (firstRender = false), 1000);
      }
      // const isRecurring = Boolean(hit.meta?.custom?.is_product_recurring);
      const hitImage = algoliaShopify.helpers.renderImage(hit, 600);
      return html`
        <div
          class="ais-hit ais-product yk-custom-styles ${firstRender ? 'yk-search-results' : ''}"
          data-algolia-index="${hit.index}"
          data-algolia-position="${hit.productPosition}"
          data-algolia-queryid="${hit.queryID}"
          data-algolia-objectid="${hit.objectID}"
          data-handle="${hit.handle}"
          data-variant-id="${hit.objectID}"
          data-distinct="${hit._distinct}"
          data-product-id="${hit.id}"
          onClick="${() => trackSearchAttribution(hit)}"
        >
          <img
            class="ais-hit--picture"
            src="${hitImage.src}"
            srcset="${hitImage.srcset}"
            sizes="${hitImage.sizes}"
            alt="${hit.title} - ${hit.variant_title}"
          />

          <div class="ais-hit--details">
            <p class="ais-hit--title">
              <a
                data-algolia-index="${hit.index}"
                data-algolia-position="${hit.productPosition}"
                data-algolia-queryid="${hit.queryID}"
                data-algolia-objectid="${hit.objectID}"
                href="${algoliaShopify.helpers.instantsearchLink(hit)}"
                title="${algoliaShopify.helpers.fullTitle(hit.title, hit._distinct, hit.variant_title)}"
              >
                ${components.Highlight({ attribute: 'title', hit })}
                ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
              </a>
            </p>
            <p class="ais-hit--price">
              ${hit.variants_max_price > hit.variants_min_price ? 'od ' : ''}
              ${new Intl.NumberFormat('pl-PL', {
                style: 'currency',
                currency: 'PLN',
              }).format(hit.variants_min_price)}
            </p>
          </div>
        </div>
      `;
    }
  );

  algoliaShopify.hooks.registerHook('beforeInstantSearchStatsTemplate', function (_tpl, { hitsPerPage, nbHits, page }) {
    const pageFrom = nbHits ? page * hitsPerPage + 1 : 0;
    const pageTo = nbHits ? Math.min((page + 1) * hitsPerPage, nbHits) : nbHits;
    return `<div class="ais-Stats yk-stats">${pageFrom} – ${pageTo} z ${nbHits} wyników</div>`;
  });

  algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', function () {
    const { widgets } = window.algoliaShopify.externals;
    const searchBox = widgets.searchBox({
      container: '.ais-search-box-container',
      placeholder: 'Szukaj po nazwie, potrzebie, opisie…',
      showReset: true,
      showSubmit: true,
      showLoadingIndicator: false,
    });

    const translateSortSelect = () => {
      const el = document.querySelector('.ais-sort');
      const select = el.querySelector('.ais-sort-orders-container');
      if (el) {
        el.innerHTML = `Sortuj według:`;
        el.insertAdjacentElement('beforeend', select);
      }
    };
    const translateShowFilters = () => {
      const el = document.querySelector('.ais-page > .ais-facets-button');
      if (!el) return;
      el.innerText = 'Pokaż filtry';
      el.onclick = () => el.remove();
    };
    const handlePageTitle = (renderOptions) => {
      const { results, state } = renderOptions;

      const nbHits = results ? results.nbHits : 0;
      const q = state?.query ? state.query.trim() : '';
      const base =
        document.querySelector('meta[property="og:site_name"]')?.content ||
        document.title.replace(/\s[–|-]\s.+$/, '') ||
        '';

      document.title = q
        ? `Wyniki dla "${q}"${base ? ' — ' + base : ''}`
        : `Wyniki: ${nbHits}${base ? ' — ' + base : ''}`;
    };

    const uiTweaksWidget = {
      init() {
        translateSortSelect();
        translateShowFilters();
      },
      render(renderOptions) {
        translateSortSelect();
        translateShowFilters();
        handlePageTitle(renderOptions);
      },
      $$type: 'yk.uiTweaks',
    };
    return [searchBox, uiTweaksWidget];
  });

  const W = window.algoliaShopify?.externals?.widgets || {};
  const T = {
    sortBy: {
      relevance: 'Trafność',
      popularity: 'Popularność',
      price_asc: 'Cena: rosnąco',
      price_desc: 'Cena: malejąco',
      newest: 'Najnowsze',
    },
  };

  if (W.sortBy) {
    const origSortBy = W.sortBy;
    W.sortBy = function wrappedSortBy(opts) {
      const mappedItems = (opts.items || []).map((it) => {
        const v = (it.value || '').toLowerCase();
        const lbl =
          T.sortBy[v] ||
          (/(relev|ranking)/i.test(v)
            ? T.sortBy.relevance
            : /(popul|sales|bestsell)/i.test(v)
              ? T.sortBy.popularity
              : /(price.*asc|asc.*price)/i.test(v)
                ? T.sortBy.price_asc
                : /(price.*desc|desc.*price)/i.test(v)
                  ? T.sortBy.price_desc
                  : /(date|new|created)/i.test(v)
                    ? T.sortBy.newest
                    : T.sortBy[it.label?.toLowerCase()] || it.label);

        return { ...it, label: lbl };
      });

      return origSortBy({ ...opts, items: mappedItems });
    };
  }

  algoliaShopify.hooks.registerHook('beforeInstantSearchNoResultTemplate', function (_defaultTemplate, html) {
    return html`
      <div class="ais-hit-empty yk-custom-padding-align">
        <div class="ais-hit-empty--title">Brak wyników</div>
        <div class="ais-hit-empty--clears">Spróbuj wyczyścić filtry lub zmienić dane wejściowe</div>
      </div>
    `;
  });
});
